module.exports = __webpack_public_path__ + "img/pet-passport_B09T63D4B1.4c96a5dd.jpg";